import { render, staticRenderFns } from "./ManOfSciResPerIn.vue?vue&type=template&id=628b27a6&scoped=true&"
import script from "./ManOfSciResPerIn.vue?vue&type=script&lang=js&"
export * from "./ManOfSciResPerIn.vue?vue&type=script&lang=js&"
import style0 from "./ManOfSciResPerIn.vue?vue&type=style&index=0&id=628b27a6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628b27a6",
  null
  
)

export default component.exports